import { defineNuxtPlugin } from '#app/nuxt'
import { LazyPrimeAutoComplete, LazyPrimeCalendar, LazyPrimeCascadeSelect, LazyPrimeCheckbox, LazyPrimeCheckboxGroup, LazyPrimeChips, LazyPrimeColorPicker, LazyPrimeDatePicker, LazyPrimeDropdown, LazyPrimeEditor, LazyPrimeFloatLabel, LazyPrimeFluid, LazyPrimeIconField, LazyPrimeIftaLabel, LazyPrimeInputChips, LazyPrimeInputGroup, LazyPrimeInputGroupAddon, LazyPrimeInputIcon, LazyPrimeInputMask, LazyPrimeInputNumber, LazyPrimeInputOtp, LazyPrimeInputSwitch, LazyPrimeInputText, LazyPrimeKnob, LazyPrimeListbox, LazyPrimeMultiSelect, LazyPrimePassword, LazyPrimeRadioButton, LazyPrimeRadioButtonGroup, LazyPrimeRating, LazyPrimeSelect, LazyPrimeSelectButton, LazyPrimeSlider, LazyPrimeTextarea, LazyPrimeToggleButton, LazyPrimeToggleSwitch, LazyPrimeTreeSelect, LazyPrimeButton, LazyPrimeButtonGroup, LazyPrimeSpeedDial, LazyPrimeSplitButton, LazyPrimeColumn, LazyPrimeRow, LazyPrimeColumnGroup, LazyPrimeDataTable, LazyPrimeDataView, LazyPrimeOrderList, LazyPrimeOrganizationChart, LazyPrimePaginator, LazyPrimePickList, LazyPrimeTree, LazyPrimeTreeTable, LazyPrimeTimeline, LazyPrimeVirtualScroller, LazyPrimeAccordion, LazyPrimeAccordionPanel, LazyPrimeAccordionHeader, LazyPrimeAccordionContent, LazyPrimeAccordionTab, LazyPrimeCard, LazyPrimeDeferredContent, LazyPrimeDivider, LazyPrimeFieldset, LazyPrimePanel, LazyPrimeScrollPanel, LazyPrimeSplitter, LazyPrimeSplitterPanel, LazyPrimeStepper, LazyPrimeStepList, LazyPrimeStep, LazyPrimeStepItem, LazyPrimeStepPanels, LazyPrimeStepPanel, LazyPrimeTabView, LazyPrimeTabs, LazyPrimeTabList, LazyPrimeTab, LazyPrimeTabPanels, LazyPrimeTabPanel, LazyPrimeToolbar, LazyPrimeConfirmDialog, LazyPrimeConfirmPopup, LazyPrimeDialog, LazyPrimeDrawer, LazyPrimeDynamicDialog, LazyPrimeOverlayPanel, LazyPrimePopover, LazyPrimeSidebar, LazyPrimeFileUpload, LazyPrimeBreadcrumb, LazyPrimeContextMenu, LazyPrimeDock, LazyPrimeMenu, LazyPrimeMenubar, LazyPrimeMegaMenu, LazyPrimePanelMenu, LazyPrimeSteps, LazyPrimeTabMenu, LazyPrimeTieredMenu, LazyPrimeChart, LazyPrimeMessage, LazyPrimeInlineMessage, LazyPrimeToast, LazyPrimeCarousel, LazyPrimeGalleria, LazyPrimeImage, LazyPrimeImageCompare, LazyPrimeAvatar, LazyPrimeAvatarGroup, LazyPrimeBadge, LazyPrimeBlockUI, LazyPrimeChip, LazyPrimeInplace, LazyPrimeMeterGroup, LazyPrimeOverlayBadge, LazyPrimeScrollTop, LazyPrimeSkeleton, LazyPrimeProgressBar, LazyPrimeProgressSpinner, LazyPrimeTag, LazyPrimeTerminal } from '#components'
const lazyGlobalComponents = [
  ["PrimeAutoComplete", LazyPrimeAutoComplete],
["PrimeCalendar", LazyPrimeCalendar],
["PrimeCascadeSelect", LazyPrimeCascadeSelect],
["PrimeCheckbox", LazyPrimeCheckbox],
["PrimeCheckboxGroup", LazyPrimeCheckboxGroup],
["PrimeChips", LazyPrimeChips],
["PrimeColorPicker", LazyPrimeColorPicker],
["PrimeDatePicker", LazyPrimeDatePicker],
["PrimeDropdown", LazyPrimeDropdown],
["PrimeEditor", LazyPrimeEditor],
["PrimeFloatLabel", LazyPrimeFloatLabel],
["PrimeFluid", LazyPrimeFluid],
["PrimeIconField", LazyPrimeIconField],
["PrimeIftaLabel", LazyPrimeIftaLabel],
["PrimeInputChips", LazyPrimeInputChips],
["PrimeInputGroup", LazyPrimeInputGroup],
["PrimeInputGroupAddon", LazyPrimeInputGroupAddon],
["PrimeInputIcon", LazyPrimeInputIcon],
["PrimeInputMask", LazyPrimeInputMask],
["PrimeInputNumber", LazyPrimeInputNumber],
["PrimeInputOtp", LazyPrimeInputOtp],
["PrimeInputSwitch", LazyPrimeInputSwitch],
["PrimeInputText", LazyPrimeInputText],
["PrimeKnob", LazyPrimeKnob],
["PrimeListbox", LazyPrimeListbox],
["PrimeMultiSelect", LazyPrimeMultiSelect],
["PrimePassword", LazyPrimePassword],
["PrimeRadioButton", LazyPrimeRadioButton],
["PrimeRadioButtonGroup", LazyPrimeRadioButtonGroup],
["PrimeRating", LazyPrimeRating],
["PrimeSelect", LazyPrimeSelect],
["PrimeSelectButton", LazyPrimeSelectButton],
["PrimeSlider", LazyPrimeSlider],
["PrimeTextarea", LazyPrimeTextarea],
["PrimeToggleButton", LazyPrimeToggleButton],
["PrimeToggleSwitch", LazyPrimeToggleSwitch],
["PrimeTreeSelect", LazyPrimeTreeSelect],
["PrimeButton", LazyPrimeButton],
["PrimeButtonGroup", LazyPrimeButtonGroup],
["PrimeSpeedDial", LazyPrimeSpeedDial],
["PrimeSplitButton", LazyPrimeSplitButton],
["PrimeColumn", LazyPrimeColumn],
["PrimeRow", LazyPrimeRow],
["PrimeColumnGroup", LazyPrimeColumnGroup],
["PrimeDataTable", LazyPrimeDataTable],
["PrimeDataView", LazyPrimeDataView],
["PrimeOrderList", LazyPrimeOrderList],
["PrimeOrganizationChart", LazyPrimeOrganizationChart],
["PrimePaginator", LazyPrimePaginator],
["PrimePickList", LazyPrimePickList],
["PrimeTree", LazyPrimeTree],
["PrimeTreeTable", LazyPrimeTreeTable],
["PrimeTimeline", LazyPrimeTimeline],
["PrimeVirtualScroller", LazyPrimeVirtualScroller],
["PrimeAccordion", LazyPrimeAccordion],
["PrimeAccordionPanel", LazyPrimeAccordionPanel],
["PrimeAccordionHeader", LazyPrimeAccordionHeader],
["PrimeAccordionContent", LazyPrimeAccordionContent],
["PrimeAccordionTab", LazyPrimeAccordionTab],
["PrimeCard", LazyPrimeCard],
["PrimeDeferredContent", LazyPrimeDeferredContent],
["PrimeDivider", LazyPrimeDivider],
["PrimeFieldset", LazyPrimeFieldset],
["PrimePanel", LazyPrimePanel],
["PrimeScrollPanel", LazyPrimeScrollPanel],
["PrimeSplitter", LazyPrimeSplitter],
["PrimeSplitterPanel", LazyPrimeSplitterPanel],
["PrimeStepper", LazyPrimeStepper],
["PrimeStepList", LazyPrimeStepList],
["PrimeStep", LazyPrimeStep],
["PrimeStepItem", LazyPrimeStepItem],
["PrimeStepPanels", LazyPrimeStepPanels],
["PrimeStepPanel", LazyPrimeStepPanel],
["PrimeTabView", LazyPrimeTabView],
["PrimeTabs", LazyPrimeTabs],
["PrimeTabList", LazyPrimeTabList],
["PrimeTab", LazyPrimeTab],
["PrimeTabPanels", LazyPrimeTabPanels],
["PrimeTabPanel", LazyPrimeTabPanel],
["PrimeToolbar", LazyPrimeToolbar],
["PrimeConfirmDialog", LazyPrimeConfirmDialog],
["PrimeConfirmPopup", LazyPrimeConfirmPopup],
["PrimeDialog", LazyPrimeDialog],
["PrimeDrawer", LazyPrimeDrawer],
["PrimeDynamicDialog", LazyPrimeDynamicDialog],
["PrimeOverlayPanel", LazyPrimeOverlayPanel],
["PrimePopover", LazyPrimePopover],
["PrimeSidebar", LazyPrimeSidebar],
["PrimeFileUpload", LazyPrimeFileUpload],
["PrimeBreadcrumb", LazyPrimeBreadcrumb],
["PrimeContextMenu", LazyPrimeContextMenu],
["PrimeDock", LazyPrimeDock],
["PrimeMenu", LazyPrimeMenu],
["PrimeMenubar", LazyPrimeMenubar],
["PrimeMegaMenu", LazyPrimeMegaMenu],
["PrimePanelMenu", LazyPrimePanelMenu],
["PrimeSteps", LazyPrimeSteps],
["PrimeTabMenu", LazyPrimeTabMenu],
["PrimeTieredMenu", LazyPrimeTieredMenu],
["PrimeChart", LazyPrimeChart],
["PrimeMessage", LazyPrimeMessage],
["PrimeInlineMessage", LazyPrimeInlineMessage],
["PrimeToast", LazyPrimeToast],
["PrimeCarousel", LazyPrimeCarousel],
["PrimeGalleria", LazyPrimeGalleria],
["PrimeImage", LazyPrimeImage],
["PrimeImageCompare", LazyPrimeImageCompare],
["PrimeAvatar", LazyPrimeAvatar],
["PrimeAvatarGroup", LazyPrimeAvatarGroup],
["PrimeBadge", LazyPrimeBadge],
["PrimeBlockUI", LazyPrimeBlockUI],
["PrimeChip", LazyPrimeChip],
["PrimeInplace", LazyPrimeInplace],
["PrimeMeterGroup", LazyPrimeMeterGroup],
["PrimeOverlayBadge", LazyPrimeOverlayBadge],
["PrimeScrollTop", LazyPrimeScrollTop],
["PrimeSkeleton", LazyPrimeSkeleton],
["PrimeProgressBar", LazyPrimeProgressBar],
["PrimeProgressSpinner", LazyPrimeProgressSpinner],
["PrimeTag", LazyPrimeTag],
["PrimeTerminal", LazyPrimeTerminal],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
